import { VOIP_API } from "../index"

export const TASK_GROUPS_API_ENDPOINTS = {
  create(data={}){
    return VOIP_API.axios.voip.request({
      url: "taskgroups",
      method: "POST",
      data,
    })
  },
  list(params={},token){
    return VOIP_API.axios.voip.request({
      url: "taskgroups",
      method: "GET",
      params,
      cancelToken: token,
    })
  },
  delete(id='',data={}){
    return VOIP_API.axios.voip.request({
      url: `taskgroups/${id}`,
      method: "DELETE",
      data,
    })
  },
  find(id='',params={}){
    return VOIP_API.axios.voip.request({
      url: `taskgroups/${id}`,
      method: "GET",
      params,
    })
  },
  update(id='',data={}){
    return VOIP_API.axios.voip.request({
      url: `taskgroups/${id}`,
      method: "PATCH",
      data,
    })
  },
  getSpaceTaskData(params={}){
    return VOIP_API.axios.voip.request({
      url: `get-space-task-data`,
      method: "GET",
      params,
    })
  },
}